module.exports = __webpack_public_path__ + "static/media/F-2.93b6c975.webp";